import { DeleteOutlined, DoneOutlineOutlined, SaveOutlined } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export interface WarehouseActionMenuButtonsProps {
    allowSaveAndCompleted: boolean;
    handleSave: () => void;
    handleCompleted: () => void;
    handleDeleted: () => void;
}

export default function WarehouseActionMenuButtons(props: Readonly<WarehouseActionMenuButtonsProps>) {
    const { allowSaveAndCompleted, handleSave, handleCompleted, handleDeleted } = props;
    const { t } = useTranslation();

    return (
        <Stack spacing={2} direction={'row'} mr={2}>
            <Button onClick={handleSave} disabled={!allowSaveAndCompleted} startIcon={<SaveOutlined />} variant='contained' size='small'>{t('warehouses.save')}</Button>
            <Button onClick={handleCompleted} disabled={!allowSaveAndCompleted} startIcon={<DoneOutlineOutlined />} variant='contained' size='small'>{t('warehouses.complete')}</Button>
            <Button onClick={handleDeleted} startIcon={<DeleteOutlined />} variant='contained' size='small'>{t('warehouses.delete')}</Button>
        </Stack>
    );
}
